import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SortingColumn from '#component/table/sorting-column/sorting-column';
import PreloaderComponent from '#component/preloader';
import LogInlineLink from '#component/general/log-inline-link';
import eventFormatter from '#component/device/event-formatter';
import { isAdminAccess, isSystem } from '#component/general/helper';
import { PaperWrapper, StyledTable, LoadingTable, LogTimeCell, ActorCell } from './styles';

const systemActor = () => (
  <div>
    <AdminPanelSettingsIcon fontSize="small" />
    <span> System</span>
  </div>
);

const userActor = actor => (
  <LogInlineLink
    to={`/user/${actor.id}`}
    text={`${actor.firstName ?? ''} ${actor.lastName ?? ''}`.trim()}
  />
);

const createActor = (log, account) => {
  if (log?.actor && isAdminAccess(account)) {
    if (isSystem(log?.actor.id)) return systemActor();
    return userActor(log.actor);
  }
  return '';
};

const LogsTableView = ({
  account,
  logs,
  loading,
  error,
  handleRequestSort,
  order,
  renderActionCell,
  EmptyStateComponent
}) => {
  const TableComponent = loading ? LoadingTable : StyledTable;

  if (!logs.length && loading) return <PreloaderComponent />;
  if (error) return EmptyStateComponent ? <EmptyStateComponent /> : null;
  if (!logs.length) return EmptyStateComponent ? <EmptyStateComponent /> : null;

  return (
    <PaperWrapper className="default-table">
      <TableComponent>
        <TableHead>
          <TableRow>
            <SortingColumn
              width="15%"
              id="time"
              title="Time"
              order={order}
              orderBy="time"
              onRequestSort={handleRequestSort}
            />
            <TableCell align="left" width="10%">
              Action
            </TableCell>
            <TableCell align="left" width="50%">
              Description
            </TableCell>
            {isAdminAccess(account) && (
              <TableCell align="left" width="15%">
                Actor
              </TableCell>
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {logs.map((log, i) => {
            const actor = createActor(log, account);
            return (
              <TableRow key={i}>
                <TableCell align="left">
                  <LogTimeCell>
                    {eventFormatter(log, account)}
                  </LogTimeCell>
                </TableCell>
                <TableCell align="left">
                  {log.event?.label}
                </TableCell>
                <TableCell align="left">
                  {renderActionCell ? renderActionCell(log, account) : null}
                </TableCell>

                {isAdminAccess(account) && (
                  <TableCell align="left">
                    <ActorCell>
                      {actor}
                    </ActorCell>
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>

      </TableComponent>
    </PaperWrapper>
  );
};

export default LogsTableView;
